<ng-template #statusBadge let-cls="cls" let-label="label">
  <span class="status" [ngClass]="cls">
    @if (cls === 'pass') {
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.9987 1.33594C4.3227 1.33594 1.33203 4.3266 1.33203 8.0026C1.33203 11.6786 4.3227 14.6693 7.9987 14.6693C11.6747 14.6693 14.6654 11.6786 14.6654 8.0026C14.6654 4.3266 11.6747 1.33594 7.9987 1.33594ZM6.66603 10.9446L4.1907 8.4746L5.13203 7.5306L6.6647 9.0606L10.194 5.53127L11.1367 6.47394L6.66603 10.9446Z" fill="#50AD41"/>
      </svg>
    } @else if (cls === 'fail') {
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M6.63533 0C2.97667 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3287 0 6.63533 0ZM7.33333 10H6V8.66667H7.33333V10ZM7.33333 7.33333H6V3.33333H7.33333V7.33333Z" fill="#FF7F00"/>
      </svg>
    } @else if (cls === 'pending') {
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M6.66667 0C2.99067 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3427 0 6.66667 0ZM8.862 9.80467L6 6.94267V2.66667H7.33333V6.39067L9.80467 8.862L8.862 9.80467Z" fill="#3873C9"/>
      </svg>
    }
    {{ label }}
  </span>
</ng-template>

@for (section of sections; track section.type) {
  @if (getSectionGroups(section); as sectionGroups) {
    @if (sectionGroups.length > 0) {
    <section class="checklist-section">
      <h3>{{ section.title }}</h3>

      @for (group of sectionGroups; track group.id) {
        <div class="checklist-accordion" [class.checklist-accordion--open]="isGroupExpanded(group)">
          <button
            type="button"
            class="checklist-accordion__header"
            [attr.aria-expanded]="isGroupExpanded(group)"
            (click)="toggleGroup(group)">
            <span class="checklist-accordion__title">
              {{ group.name }}
              <span class="checklist-accordion__count">{{ group.rows.length }}</span>
            </span>

            <span class="checklist-accordion__meta">
              @if (getGroupStatus(group, section); as status) {
                <ng-container *ngTemplateOutlet="statusBadge; context: { cls: status.class, label: status.label }"></ng-container>
              }
              <svg class="checklist-accordion__chevron" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M6 9L12 15L18 9" stroke="#9FA1A4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </button>

          @if (isGroupExpanded(group)) {
            <div class="checklist-accordion__body">
              @if (showColumnHeaders(section)) {
                <div class="checklist-table__header checklist-table__row" [style.grid-template-columns]="getGridTemplate(section.columns)">
                  @for (column of section.columns; track trackColumn(columnIndex, column); let columnIndex = $index) {
                    <div
                      class="checklist-table__cell"
                      [class.checklist-table__cell--name]="columnIndex === 0"
                      [ngClass]="'checklist-table__cell--' + (column.align ?? 'left')">
                      {{ getColumnHeader(column) }}
                    </div>
                  }
                </div>
              }

              @for (row of group.rows; track trackRow($index, row)) {
                @if (rowTemplate) {
                  <div class="checklist-table__row checklist-table__row--templated">
                    <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: row, group: group }"></ng-container>
                  </div>
                } @else {
                <div class="checklist-table__row" [style.grid-template-columns]="getGridTemplate(section.columns)">
                  @for (column of section.columns; track trackColumn(columnIndex, column); let columnIndex = $index) {
                    <div
                      class="checklist-table__cell"
                      [class.checklist-table__cell--name]="columnIndex === 0"
                      [ngClass]="'checklist-table__cell--' + (column.align ?? 'left')">
                      @switch (column.type) {
                        @case ('status') {
                          <ng-container *ngTemplateOutlet="statusBadge; context: { cls: getStatusClass(row, column), label: getStatusLabel(row, column) }"></ng-container>
                        }
                        @case ('checkbox') {
                          <input
                            type="checkbox"
                            class="form-check-input checklist-checkbox"
                            [checked]="getCellValue(row, column)"
                            (click)="$event.stopPropagation()"
                            (change)="onCheckboxChange($event, row, group, column)" />
                        }
                        @case ('action') {
                          <button
                            type="button"
                            class="checklist-action-btn"
                            [attr.aria-label]="column.actionLabel ?? column.header ?? ('compliance.shared.checklistTable.action' | transloco)"
                            (click)="onActionClick($event, row, group, column)">
                            @if(column.actionName === 'restore') {
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M7 9.33594C7.97475 9.33594 8.75 8.55952 8.75 7.58594C8.75 6.61235 7.97475 5.83594 7 5.83594C6.02525 5.83594 5.25 6.61235 5.25 7.58594C5.25 8.55952 6.02525 9.33594 7 9.33594Z" fill="#9FA1A4"/>
                                <path d="M12.1432 6.52256C12.0732 6.18248 11.97 5.85115 11.837 5.5379C11.7057 5.22756 11.543 4.92773 11.3528 4.64481C11.1638 4.3654 10.9486 4.10465 10.7123 3.86956C10.4767 3.63273 10.2147 3.4169 9.93533 3.22731C9.65358 3.03715 9.35317 2.87498 9.044 2.74373C8.73017 2.61015 8.39883 2.50748 8.05758 2.4369C7.70758 2.36515 7.3465 2.33073 6.98542 2.3319V1.16406L4.66667 2.91406L6.98542 4.66406V3.49856C7.26775 3.4974 7.55008 3.52423 7.8225 3.58023C8.08733 3.63506 8.34517 3.71498 8.589 3.81881C8.82992 3.92031 9.06325 4.04748 9.282 4.19448C9.49958 4.34148 9.70317 4.50948 9.8875 4.6944C10.0712 4.87756 10.2398 5.08115 10.3857 5.29815C10.5338 5.51748 10.6604 5.75081 10.7625 5.9929C10.8663 6.23615 10.9457 6.49398 11.0005 6.75765C11.0553 7.0254 11.0833 7.30248 11.0833 7.58073C11.0833 7.85898 11.0553 8.13606 11.0005 8.40323C10.9457 8.66806 10.8663 8.9259 10.7625 9.17031C10.6604 9.41123 10.5338 9.64456 10.3868 9.86331C10.2392 10.0809 10.0707 10.2845 9.88633 10.4694C9.70258 10.6537 9.49958 10.8211 9.282 10.9676C9.065 11.114 8.83225 11.2406 8.58842 11.3438C8.34517 11.4471 8.08792 11.527 7.82367 11.5818C7.287 11.6915 6.71183 11.6915 6.1775 11.5818C5.91267 11.527 5.65483 11.4471 5.411 11.3432C5.16833 11.2406 4.93558 11.114 4.71742 10.967C4.501 10.8211 4.298 10.6531 4.11367 10.4688C3.92992 10.2845 3.76133 10.0809 3.61492 9.86448C3.46675 9.64515 3.34017 9.41181 3.23808 9.17031C3.13425 8.92648 3.05492 8.66865 3.00008 8.40498C2.94467 8.13606 2.91667 7.85898 2.91667 7.58073H1.75C1.75 7.93715 1.78617 8.29298 1.85675 8.6389C1.92675 8.9784 2.03 9.30973 2.163 9.62415C2.29425 9.93448 2.457 10.2343 2.64775 10.5172C2.83617 10.7955 3.05142 11.0562 3.28767 11.2925C3.5245 11.5299 3.78583 11.7457 4.06408 11.9336C4.3435 12.1231 4.64392 12.2859 4.956 12.4177C5.26983 12.5513 5.60117 12.654 5.94242 12.7246C6.28775 12.7946 6.64358 12.8307 7 12.8307C7.35642 12.8307 7.71225 12.7946 8.05817 12.724C8.39825 12.6534 8.72958 12.5507 9.04283 12.4177C9.35608 12.2853 9.6565 12.1226 9.93533 11.9336C10.2142 11.7457 10.4755 11.5299 10.7118 11.2925C10.948 11.0562 11.1632 10.7949 11.3534 10.5155C11.543 10.2337 11.7057 9.93331 11.837 9.62415C11.9706 9.30915 12.0732 8.97781 12.1432 8.63715C12.2138 8.29298 12.25 7.93715 12.25 7.58073C12.25 7.22431 12.2138 6.86848 12.1432 6.52256Z" fill="#9FA1A4"/>
                              </svg>
                            } @else {
                              <i [class]="column.actionIcon ?? 'ph ph-archive'"></i>
                            }
                          </button>
                        }
                        @case ('link') {
                          @if (hasLinkUrl(row, column)) {
                            <button
                              type="button"
                              class="checklist-link"
                              [attr.aria-label]="column.actionLabel ?? column.header ?? ('compliance.shared.checklistTable.view' | transloco)"
                              (click)="onActionClick($event, row, group, column)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M7.49805 11C8.32647 11 8.99805 10.3284 8.99805 9.5C8.99805 8.67157 8.32647 8 7.49805 8C6.66962 8 5.99805 8.67157 5.99805 9.5C5.99805 10.3284 6.66962 11 7.49805 11Z" fill="#9FA1A4"/>
                                <path d="M10.498 14L8.99805 12L5.99805 16H8.99805H11.998H17.998L13.498 10L10.498 14Z" fill="#9FA1A4"/>
                                <path d="M19.998 4H3.99805C2.89505 4 1.99805 4.897 1.99805 6V18C1.99805 19.103 2.89505 20 3.99805 20H19.998C21.101 20 21.998 19.103 21.998 18V6C21.998 4.897 21.101 4 19.998 4ZM3.99805 18V6H19.998L20 18H3.99805Z" fill="#9FA1A4"/>
                              </svg>
                              <span>{{ getCellValue(row, column) }}</span>
                            </button>
                          } @else {
                            @if (isMutedValue(row, column)) {
                              <span class="checklist-muted">{{ getCellValue(row, column) }}</span>
                            } @else {
                              {{ getCellValue(row, column) }}
                            }
                          }
                        }
                        @case ('attach') {
                          @if (hasLinkUrl(row, column)) {
                            <button
                              type="button"
                              class="checklist-link checklist-link--stacked"
                              [attr.aria-label]="column.actionLabel ?? column.header ?? ('compliance.shared.checklistTable.view' | transloco)"
                              (click)="onActionClick($event, row, group, column)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                <path d="M14 2H6C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V8L14 2ZM14 4.414L17.586 8H14V4.414ZM6 20V4H12V10H18L18.001 20H6Z" fill="#9FA1A4"/>
                              </svg>
                              <span class="checklist-link__text">
                                <span class="checklist-link__primary">{{ getCellValue(row, column) }}</span>
                                @if (getSubLabel(row, column); as subLabel) {
                                  <span class="checklist-link__secondary">{{ subLabel }}</span>
                                }
                              </span>
                            </button>
                          } @else if (isAttachUnavailable(row, column)) {
                            <span class="checklist-muted">{{ column.attachUnavailableLabel ?? ('compliance.shared.checklistTable.noDocument' | transloco) }}</span>
                          } @else {
                            <button
                              type="button"
                              class="checklist-attach"
                              [attr.aria-label]="column.attachLabel ?? ('compliance.shared.checklistTable.attach' | transloco)"
                              (click)="onAttachClick($event, row, group, column)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M5.64383 7.52871C6.39917 6.77338 7.7165 6.77338 8.47183 7.52871L8.94317 8.00004L9.88583 7.05738L9.4145 6.58604C8.78583 5.95671 7.9485 5.60938 7.05783 5.60938C6.16717 5.60938 5.32983 5.95671 4.70117 6.58604L3.2865 8.00004C1.98783 9.29938 1.98783 11.4147 3.2865 12.714C3.9365 13.364 4.78983 13.6887 5.64317 13.6887C6.49717 13.6887 7.35117 13.364 8.0005 12.714L8.47183 12.2427L7.52917 11.3L7.05783 11.7714C6.27783 12.5494 5.00917 12.5507 4.22917 11.7714C3.44983 10.9914 3.44983 9.72271 4.22917 8.94271L5.64383 7.52871Z" fill="#EE2737"/>
                                <path d="M7.99861 3.28725L7.52728 3.75858L8.46995 4.70125L8.94128 4.22992C9.72061 3.45192 10.9893 3.45058 11.7699 4.22992C12.5493 5.00992 12.5493 6.27858 11.7699 7.05858L10.3553 8.47258C9.59995 9.22792 8.28261 9.22792 7.52728 8.47258L7.05595 8.00125L6.11328 8.94392L6.58461 9.41525C7.21328 10.0446 8.05061 10.3919 8.94128 10.3919C9.83195 10.3919 10.6693 10.0446 11.2979 9.41525L12.7126 8.00125C14.0113 6.70192 14.0113 4.58658 12.7126 3.28725C11.4126 1.98725 9.29728 1.98792 7.99861 3.28725Z" fill="#EE2737"/>
                              </svg>
                              <span>{{ column.attachLabel ?? ('compliance.shared.checklistTable.attach' | transloco) }}</span>
                            </button>
                          }
                        }
                        @case ('toggle') {
                          <label class="checklist-toggle" (click)="$event.stopPropagation()">
                            <input
                              type="checkbox"
                              [checked]="getCellValue(row, column)"
                              (change)="onToggleChange($event, row, group, column)" />
                            <span></span>
                          </label>
                        }
                        @default {
                          @if (isMutedValue(row, column)) {
                            <span class="checklist-muted">{{ getCellValue(row, column) }}</span>
                          } @else {
                            {{ getCellValue(row, column) }}
                          }
                        }
                      }
                    </div>
                  }
                </div>
                }
              }

              @if (groupFooterTemplate) {
                <ng-container *ngTemplateOutlet="groupFooterTemplate; context: { $implicit: group }"></ng-container>
              }

            </div>
          }
        </div>
      }
    </section>
    }
  }
}
